import React from 'react';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import HistorySection from './components/HistorySection';
import AchievementsSection from './components/AchievementsSection';
import LeadershipLegacySection from './components/LeadershipLegacySection';
import ValuesSection from './components/ValuesSection';
import Footer from '../../components/ui/Footer';
import FAQSection from './components/FAQSection';

const AboutHeritage = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />

      <main className="pt-16">
        <HeroSection />
        <HistorySection />
        <AchievementsSection />
        <LeadershipLegacySection />
        <ValuesSection />
      </main>
      <Footer />
    </div>
  );
};

export default AboutHeritage;